/**
 * The tab-local copies of the same morpheme panels route family.
 * Panel→panel navigation (similar graphemes, sentence words) must push into the SAME bottom tab's
 * copy, or the user gets stranded in a stack their back control never meant to leave.
 */
const DECK_MORPHEME_PANELS_HREF = "/(nav)/(app)/decks/morpheme/[morpheme]";
const COLLECTIONS_MORPHEME_PANELS_HREF = "/(nav)/(app)/collections/morpheme/[morpheme]";
const EXPLORE_MORPHEME_PANELS_HREF = "/(nav)/(app)/learn/explore/morpheme/[morpheme]";
const MAP_MORPHEME_PANELS_HREF = "/(nav)/(app)/learn/map/morpheme/[morpheme]";
const BROWSE_MORPHEME_PANELS_HREF = "/(nav)/(app)/browse/morpheme/[morpheme]";

const DECKS_TAB_HREF_PREFIX = "/(nav)/(app)/decks/";
const COLLECTIONS_TAB_HREF_PREFIX = "/(nav)/(app)/collections/";
const LEARN_TAB_HREF_PREFIX = "/(nav)/(app)/learn/";
/** Learn's map keeps its own panels stack, so it is matched before the rest of Learn. */
const LEARN_MAP_HREF_PREFIX = "/(nav)/(app)/learn/map/";

/**
 * Resolves the morpheme-panels href for a panel→panel push so it stays inside the current bottom
 * tab. Learn's review/lesson routes use the Explore layout for arbitrary morphemes.
 *
 * The current panel's own `morphemeHrefObject.href` can't be reused directly: its params carry
 * the mounted screen's `morpheme`, so a same-family push deduped onto the current screen and
 * only flipped its info/mnemonics tab. Always target the bare route pattern instead.
 */
export function getInTabMorphemePanelsHref(currentMorphemeHref: string): string {
  if (currentMorphemeHref.startsWith(DECKS_TAB_HREF_PREFIX)) {
    return DECK_MORPHEME_PANELS_HREF;
  }
  if (currentMorphemeHref.startsWith(COLLECTIONS_TAB_HREF_PREFIX)) {
    return COLLECTIONS_MORPHEME_PANELS_HREF;
  }
  if (currentMorphemeHref.startsWith(LEARN_MAP_HREF_PREFIX)) {
    return MAP_MORPHEME_PANELS_HREF;
  }
  if (currentMorphemeHref.startsWith(LEARN_TAB_HREF_PREFIX)) {
    return EXPLORE_MORPHEME_PANELS_HREF;
  }
  return BROWSE_MORPHEME_PANELS_HREF;
}
